// these sizes are arbitrary and you can set them to whatever you wish
import {css} from 'styled-components';

export const sizes = {
  wide: {portrait: 1800, landscape: 1800},
  large: {portrait: 1280, landscape: 1800},
  medium: {portrait: 992, landscape: 992},
  small: {portrait: 480, landscape: 736},
  smaller: {portrait: 320, landscape: 568}
};

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const portraitSize = sizes[label].portrait / 16; // eslint-disable-line no-magic-numbers
  const landscapeSize = sizes[label].landscape / 16; // eslint-disable-line no-magic-numbers
  accumulator[label] = (...args) => css`
    @media (max-width: ${portraitSize}em) and (orientation : portrait) {
      ${css(...args)}
    }
    @media (max-width: ${landscapeSize}em) and (orientation : landscape) {
      ${css(...args)}
    }
  `;
  return accumulator;
}, {});



// WEBPACK FOOTER //
// ./styles/components/media-queries.js